export default "__VITE_ASSET__BZXdxjYl__"